import { Theme, alpha } from '@mui/material'
import { dateRangePickerDayClasses } from '@mui/x-date-pickers-pro'
import { type PickerComponents, type PickersProComponents } from '@mui/x-date-pickers-pro/themeAugmentation'

const Datepicker = (): PickersProComponents<Theme> & PickerComponents<Theme> => {
  return {
    MuiPickersDay: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&:hover': {
            backgroundColor: alpha(theme.palette.accent.main, 0.04)
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.accent.main,
            '&:hover, &:focus': {
              backgroundColor: theme.palette.accent.dark
            }
          }
        })
      }
    },
    MuiPickersYear: {
      styleOverrides: {
        selected: ({ theme }) => ({
          backgroundColor: theme.palette.accent.main,
          '&:hover, &:focus': {
            backgroundColor: theme.palette.accent.main
          }
        })
      }
    },
    MuiPickersMonth: {
      styleOverrides: {
        selected: ({ theme }) => ({
          backgroundColor: theme.palette.accent.main,
          '&:hover, &:focus': {
            backgroundColor: theme.palette.accent.main
          }
        })
      }
    },
    MuiDateRangePickerDay: {
      styleOverrides: {
        root: ({ theme }) => ({
          [`&.${dateRangePickerDayClasses.rangeIntervalDayHighlight}:not(.${dateRangePickerDayClasses.hiddenDayFiller})`]:
            {
              backgroundColor: alpha(theme.palette.accent.main, 0.12)
            }
        }),
        day: ({ theme }) => ({
          '&:hover': {
            backgroundColor: alpha(theme.palette.accent.main, 0.04)
          },
          '&.Mui-selected': {
            backgroundColor: theme.palette.accent.main,
            '&:hover, &:focus': {
              backgroundColor: theme.palette.accent.dark
            }
          }
        })
      }
    }
  }
}

export default Datepicker
